// extracted by mini-css-extract-plugin
export default {"limtDate":"index_limtDate_-ghQI","loadingBox":"index_loadingBox_h5P5p"};